<template>
  <div class="wrapper team1">
    <div class="breadcrumb">{{$t("main.nav[0].list[1].title")}}</div>
    <div class="container">
      <div class="bg">
        <section class="team item1" id="cd1">
          <div class="img">
            <img src="~assets/main/estate/team/team-cd-01.jpg"/>
          </div>
          <div class="des">
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
              <!-- 内层盒子——内容区 -->
              <div class="con">
                <div class="title">{{$t("main.des[0].list[10].title")}}</div>
                <div class="text" v-html='$t("main.des[0].list[10].text")'></div>
              </div>
            </happy-scroll>
          </div>
        </section>
        <section class="item2" id="cd2">
          <div class="img">
            <img src="~assets/main/estate/team/team-cd-02.jpg"/>
          </div>
          <div class="des">
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
              <!-- 内层盒子——内容区 -->
              <div class="con">
                <div class="title">{{$t("main.des[0].list[11].title")}}</div>
                <div class="text" v-html='$t("main.des[0].list[11].text")'></div>
              </div>
            </happy-scroll>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleSwiper',
  data () {
    return {
      resize: true
    }
  },
  mounted () {
  },
  beforeMount () {
  },
  computed: {
  },
  created () {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .des
    width 100%
    margin-top 30px
    height 120px
    .text
      padding-bottom 30px
    .title
      font-size 20px
      font-weight bold
      line-height 32px
    .des
      b
        font-weight bold
  .wrapper
    width 78%
    font-size 15px
    line-height 26px
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
      b
        font-weight normal
        margin-left 10px
    .container
      padding-left 30px
      box-sizing border-box
      .bg
        background url("~assets/main/estate/team/team-cd-bg.png")
        fullBg()
        background-position right 0
        .item1
          .img
            width 58%
          .des
            width 58%
        .item2
          display flex
          flex-flow row-reverse wrap
          margin-top 10%
          .img
            width 74%
          .des
            width 74%
            height 250px
  @media screen and (max-width: 1366px) {
    .des{
      height 95px!important
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/main/components/Team3.vue